import { Button, Modal, Spinner } from 'flowbite-react';
import { get } from 'lodash';
import React from 'react';
import { RxCross2 } from 'react-icons/rx';
import { useMutation, useQueryClient } from 'react-query';
import { reopenPosition } from 'src/apis/position';
import { useToast } from 'src/context/ToastProvider';

interface Props {
	isOpen: boolean;
	positionId: string;
	onClose: () => void;
}

const ReopenPositionConfirmationModal = ({ isOpen, positionId, onClose }: Props) => {
	const toast = useToast();
	const queryClient = useQueryClient();

	const reopenPositionFn = useMutation(['reopenPosition'], reopenPosition, {
		onSuccess() {
			toast({
				title: 'Successfully reopened position',
				duration: 3000,
				type: 'success',
			});
			queryClient.refetchQueries(['getMyRegisteredPositions']);
			onClose();
		},
		onError(error: Error) {
			const errorMessage = get(error, ['response', 'data', 'message'], error.message);
			toast({
				title: errorMessage,
				type: 'error',
			});
		},
	});

	const onConfirm = () => {
		reopenPositionFn.mutate({ id: positionId });
	};

	return (
		<Modal size="md" show={isOpen} onClose={onClose} dismissible>
			<Modal.Body className="relative rounded-[8px] border border-solid dark:border-[#4B5563] bg-whtie dark:bg-[#1F2A37]">
				<div className="text-center mt-[20px] text-[16px] font-[500] text-inherit dark:text-[#F2F2F5]">
					Are you sure you want to reopen this position?
				</div>

				<div className="flex gap-4 justify-center mt-[20px]">
					<Button onClick={onClose} color="light" className="!border !border-solid !border-[#7777E7]">
						No, cancel
					</Button>
					<Button onClick={onConfirm} color="purplePlaced" disabled={reopenPositionFn.isLoading}>
						{reopenPositionFn.isLoading ? <Spinner /> : 'Yes, I am sure'}
					</Button>
				</div>

				<RxCross2
					onClick={onClose}
					className="absolute right-[16px] top-[16px] h-[20px] w-[20px] cursor-pointer text-[#9CA3AF]"
				/>
			</Modal.Body>
		</Modal>
	);
};

export default ReopenPositionConfirmationModal;
